import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.css']
})
export class PolicyComponent implements OnInit {
  isTransportPolicyHidden: boolean = true
  isLeavePolicyHidden: boolean = true
  SCREENNAMES: string = "";
  
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(e: KeyboardEvent) {
    console.log(e);
    if (e.ctrlKey) {
      this.disabledEvent(e);
    }
    if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
      this.disabledEvent(e);
    }
    // "J" key
    if (e.ctrlKey && e.shiftKey && e.keyCode == 74) {
      this.disabledEvent(e);
    }
    // "S" key + macOS
    if (e.keyCode == 83 && (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)) {
      this.disabledEvent(e);
    }
    // "U" key
    if (e.ctrlKey && e.keyCode == 85) {
      this.disabledEvent(e);
    }
    // "F12" key
    if (e.keyCode == 123) {
      this.disabledEvent(e);
    }
    if (e.ctrlKey && e.keyCode == 65) {
      this.disabledEvent(e);
    }
  }
  disabledEvent(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    } else if (window.event) {
      window.event.cancelBubble = true;
    }
    e.preventDefault();
    return false;
  }
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.isTransportPolicyHidden = true;
    this.isLeavePolicyHidden = true;
    this.SCREENNAMES  = "";
    this.route.queryParams.subscribe(params => {
      if (params.PolicyID) {
        if (params.PolicyID == 0) {
          this.SCREENNAMES = "Leave Policy";
          this.isLeavePolicyHidden = false;
        } else if (params.PolicyID == 1) {
          this.SCREENNAMES = "Travel & Reimbursement Policy";
          this.isTransportPolicyHidden = false;
        }
        // this.GetJobData(params.JobID);
      }
    });
    //PolicyID
  }

}
